<div class="modal-buttons">
    <button [disabled]="pageModal.isSaving" class="button" (click)="cancel()"> <tra slug="btn_cancel"></tra> </button>
    <button [disabled]="pageModal.isSaving || isConfirmDisabled" class="button is-info" (click)="confirm()">
        <tra [slug]="pageModal.getCurrentModal().confirmationCaption ? pageModal.getCurrentModal().confirmationCaption : 'OK'"></tra>
    </button>
</div>